// Redux Actions
import {
  SHOW_SHORTCUTS,
  SET_STATE_SHORTCUTS,
} from "../types";

export function showShortcuts(payload) {
  return { type: SHOW_SHORTCUTS, payload }
};

export function setStateShortcuts(payload) {
  return { type: SET_STATE_SHORTCUTS, payload }
};
